import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeatureViewModel } from 'src/app/data/models/feature/feature.model';

@Injectable({ providedIn: 'root' })
export class FeatureApiService {
    private base = '/feature';
    constructor(private http: HttpClient) { }

    getAllFeatures(): Observable<FeatureViewModel[]> {
        return this.http.get<FeatureViewModel[]>(`${this.base}`);
    }

    getUserFeatures(userId: number): Observable<FeatureViewModel[]> {
        return this.http.get<FeatureViewModel[]>(`${this.base}/user/${userId}`);
    }

    setUserFeatures(userId: number, featureIds: number[]): Observable<void> {
        return this.http.post<void>(`${this.base}/user/${userId}`, featureIds);
    }
}
